// Site-wide lockdown for the showcase build: no context menu, no text
// selection, no copy/cut, no dragging content out of the page, and the usual
// keyboard shortcuts for dev tools / view source / save page are swallowed.
// Everything listens in the capture phase on window so no component handler
// can stop the event before it gets here.
//
// This is a deterrent, not security: dev tools are still reachable from the
// browser menu, and nothing client-side can truly stop copying.

const DEVTOOLS_KEYS = new Set(["KeyI", "KeyJ", "KeyC", "KeyK"]);
const PAGE_KEYS = new Set(["KeyU", "KeyS"]);

// Typing into form fields must keep working, so selection and copy/cut stay
// enabled inside them.
function isEditable(target) {
  return target instanceof Element && target.closest("input, textarea, [contenteditable]") !== null;
}

// Uses e.code rather than e.key because Option changes e.key on macOS
// (Opt+I is "ˆ"), and ignores Ctrl+Alt on Windows/Linux because that is how
// AltGr reports, which non-US layouts need for ordinary letters.
function isBlockedShortcut(e) {
  if (e.code === "F12") return true;
  if (e.metaKey) {
    return (e.altKey && DEVTOOLS_KEYS.has(e.code)) || PAGE_KEYS.has(e.code);
  }
  if (e.ctrlKey && !e.altKey) {
    return e.shiftKey ? DEVTOOLS_KEYS.has(e.code) : PAGE_KEYS.has(e.code);
  }
  return false;
}

export function installContentProtection() {
  const capture = { capture: true };
  const block = (e) => e.preventDefault();
  const blockOutsideFields = (e) => {
    if (!isEditable(e.target)) e.preventDefault();
  };

  window.addEventListener("contextmenu", block, capture);
  window.addEventListener("dragstart", block, capture);
  window.addEventListener("selectstart", blockOutsideFields, capture);
  window.addEventListener("copy", blockOutsideFields, capture);
  window.addEventListener("cut", blockOutsideFields, capture);
  window.addEventListener(
    "keydown",
    (e) => {
      if (isBlockedShortcut(e)) e.preventDefault();
    },
    capture,
  );
}
